import React, { useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug } from '@fortawesome/pro-light-svg-icons/faPlug';
import { TypedMemo } from '../../../common/types';
import { ConnectedAppMark } from './connectedApps/ConnectedAppMark';
import { aiAssistantsMessages as messages } from './aiAssistantsMessages';
import { withBrandWord } from '../../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI assistants tab; each part uses its own slice of it */
import styles from './aiAssistants.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Guide {
  /** A product name is not translated. The third block has a translated name. */
  name: string | MessageDescriptor;
  steps: MessageDescriptor[];
}

// The steps name no exact menu: the menus of the hosts change, and we did not confirm them.
const GUIDES: Guide[] = [
  { name: 'Claude', steps: [messages.claudeStep1, messages.claudeStep2, messages.approveStep] },
  { name: 'ChatGPT', steps: [messages.chatgptStep1, messages.chatgptStep2, messages.approveStep] },
  { name: messages.otherName, steps: [messages.otherStep1, messages.otherStep2, messages.approveStep] },
];

/** design: ai-assistants a1 `.ai-steps` — three short setup blocks: Claude, ChatGPT, other MCP clients. */
const AiSetupGuidesComponent: React.FC = () => {
  const intl = useIntl();
  const guides = useMemo(
    () =>
      GUIDES.map((guide) => ({
        key: typeof guide.name === 'string' ? guide.name : 'other',
        name: typeof guide.name === 'string' ? guide.name : intl.formatMessage(guide.name),
        isProduct: typeof guide.name === 'string',
        steps: guide.steps.map((step) => intl.formatMessage(step)),
      })),
    [intl]
  );
  return (
    <div className={styles.guides}>
      {guides.map((guide) => (
        <section key={guide.key} className={styles.guide} aria-label={guide.name}>
          <div className={styles.guideHead}>
            {guide.isProduct ? (
              <ConnectedAppMark clientId={guide.name} name={guide.name} />
            ) : (
              <span className={styles.plainMark} aria-hidden="true">
                <FontAwesomeIcon icon={faPlug} />
              </span>
            )}
            <b>{guide.name}</b>
          </div>
          <ol className={styles.steps}>
            {guide.steps.map((step) => (
              <li key={step}>{withBrandWord(step)}</li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
};

export const AiSetupGuides = TypedMemo(AiSetupGuidesComponent);
